import { animate, AnimationMetadata, group, query, style, transition } from '@angular/animations';

export const TRANSITION_TIME = 800; // ms

const nextAnimationGroup = group([
  query(
    '.previous',
    [
      style({
        transform: 'translateX(0%)',
      }),
      animate(
        `${TRANSITION_TIME}ms ease`,
        style({
          transform: 'translateX(-100%)',
        })
      ),
    ],
    { optional: true }
  ),
  query(
    '.current',
    [
      style({
        transform: 'translateX(100%)',
      }),
      animate(
        `${TRANSITION_TIME}ms ease`,
        style({
          transform: 'translateX(0%)',
        })
      ),
    ],
    { optional: true }
  ),
]);
const prevAnimationGroup = group([
  query(
    '.previous',
    [
      style({
        transform: 'translateX(0%)',
      }),
      animate(
        `${TRANSITION_TIME}ms ease`,
        style({
          transform: 'translateX(100%)',
        })
      ),
    ],
    { optional: true }
  ),
  query(
    '.current',
    [
      style({
        transform: 'translateX(-100%)',
      }),
      animate(
        `${TRANSITION_TIME}ms ease`,
        style({
          transform: 'translateX(0%)',
        })
      ),
    ],
    { optional: true }
  ),
]);

export const getIncrementAnimationMetadata = (isArabic: boolean): AnimationMetadata => {
  return transition(':increment', isArabic ? [prevAnimationGroup] : [nextAnimationGroup]);
};
export const getDecrementAnimationMetadata = (isArabic: boolean): AnimationMetadata => {
  return transition(':decrement', isArabic ? [nextAnimationGroup] : [prevAnimationGroup]);
};
